//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[[0,"DistanceToDieBaseEdge",1,0],[0,"IndexStringList",1,0],[0,"LengthPL",1,0],[0,"ReferencePoint",1,"Point",0],[0,"SelectConceptDieBaseSpreadsheet",1,0],[0,"SubDieBaseNumber",1,0],[0,"UpdateDieBasePositionAccordingToStrip",1,0],[0,"UseConceptDieBase",1,0],[0,"WidthPW",1,0],[0,"WizardType",1,0],[0,"XEndDistance",1,0],[0,"XStartDistance",1,0],[0,"YDistanceFirst",1,0],[0,"YDistanceSecond",1,0]],[[["expName"],"GetExpressionValue",{R_:{expressionValue:''}},1,0],[["expName","expressionValue"],"SetExpressionValue",{},2,0],[[],"SetBasePointYValue",{},0,0]],[]];
SPLM.Tooling.ConceptDieBaseBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ConceptDieBaseBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;